/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels",
    },
    (router) => {
      router.group(
        {
          path: "/:hotelId",
        },
        (router) => {
          router.push({
            id: "@api/hotel@view",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/hotel@duplicate",
                path: "/duplicate",
              });
              router.push({
                id: "@api/hotel@availability",
                path: "/availability",
              });
            },
          );
        },
      );

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api/hotel@autocomplete",
            path: "/autocomplete",
          });
        },
      );
    },
  );
}
